import React, { useEffect, useState } from 'react'
import { Col, Image, Row } from 'react-bootstrap'
import { Player } from 'video-react'
import { APIurls, Axios } from '../constants'
import { Link } from 'react-router-dom'

import toast from 'react-hot-toast'
import Loader from '../components/Loader'
import ReactPlayer from 'react-player'

const PortfolioSection = () => {
    const [active, setActive] = useState('3D')

    const [data, setData] = useState([]);
    const [reel, setReel] = useState([]);
    const [loading, setLoading] = useState(false);
    const [filter, setFilter] = useState([])

    useEffect(() => {
        getProjects()
    }, []);

    const getProjects = async () => {

        try {
            setLoading(true)
            const res = await Axios.get(APIurls?.getProjectPortfolio);
            setLoading(false)
            if (res && res?.data) {
                setData(res?.data?.data)
                setReel(res?.data?.reels)
                setFilter(res?.data?.data)
            } else {
                setLoading(false)
                setData([])
            }
        } catch (error) {
            setLoading(false)
            toast.error('issue in query');
        }
    }

    const createSlug = (text) => {
        return text
            .toLowerCase()
            .replace(/[^a-z0-9]+/g, '-')
            .replace(/^-+|-+$/g, '');
    };

    const handleFilter = (type) => {
        setActive(type)
        let newData;
        if (type === 'ColorGrading') {
            newData = data.filter((item) => item.video_type === 'ColorGrading' ? item : '');
        } else {
            newData = data.filter((item) => item.video_type !== 'ColorGrading' ? item : '');
        }
        setFilter(newData)
    }

    return (
        <div className='portfolioSection'>
            <Row>
                <Col xs={12} sm={12} md={10} lg={10} xl={8} xxl={7} className='mx-auto'>
                    <div className='animationParent'>
                        <Image src={require('./../assets/imgs/arrow.png')} alt='arrow' className='arrowImage' onClick={() => handleFilter(active == '3D' ? 'ColorGrading' : '3D')} />
                        {reel?.map((reel, r) => {
                            if (reel?.type == '3D') {
                                return (
                                    <div className={`video ${active === '3D' && 'active'}`} key={r}>
                                        <ReactPlayer className='react-player' loop muted playing controls url={reel?.video_first} />
                                    </div>
                                )
                            } else {
                                return (
                                    <div className={`video ${active === 'ColorGrading' && 'active'}`} key={r}>
                                        <ReactPlayer className='react-player' loop muted playing controls url={reel?.video_first} />
                                    </div>
                                )
                            }

                        })}

                    </div>
                </Col>
            </Row>
            {loading ? <Loader /> :
                <div className='portfolioSectionSlider'>
                    <Row className='d-flex justify-content-center'>
                        {filter?.map((project, s) => {
                            const slug = createSlug(project?.project_title)
                            const thumb = project?.media?.find((thm) => thm?.collection_name === "project_thumbnail" ? thm : '')
                            return (
                                <Col xs={12} sm={12} md={6} lg={4} xl={4} xxl={3} className='p-0' key={s}>
                                    <Link to={`/portfolio-detail/${slug}`}
                                        state={{ project: project }}
                                    >
                                        {/* <LazyLoadImage
                                            src={thumb?.original_url}
                                            // PlaceholderSrc={placeholder}
                                            effect="blur"
                                            className='img-fluid portfolio'
                                            alt={thumb?.name}
                                        /> */}
                                        <Image src={thumb?.original_url} alt={thumb?.name} width={416} height={234} className="img-fluid portfolio" />
                                    </Link>
                                </Col>
                            )
                        })}
                    </Row>
                </div>
            }
        </div>
    )
}

export default PortfolioSection